import { render } from "./TreuhandBenutzerListe.vue?vue&type=template&id=770b84b7&ts=true"
import script from "./TreuhandBenutzerListe.vue?vue&type=script&lang=ts"
export * from "./TreuhandBenutzerListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__